module.exports = __webpack_public_path__ + "static/media/home_1.b734ddbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_1.jpg
// module id = 217
// module chunks = 0